import PrimaryMenuItem from '../model/PrimaryMenuItem';

const auth = new PrimaryMenuItem('Auth', 'manage_accounts', () => import('@/pages/Auth'));

export default auth;
